import { Box, Typography, IconButton } from '@mui/material';

interface InfoBoxProps {
  iconLeft: React.ReactNode; // Ícone do lado esquerdo
  title: string; // Título do bloco de informações
  text: string; // Texto do conteúdo principal
  subText?: string; // Texto adicional (opcional)
  iconRight?: React.ReactNode; // Ícone do lado direito (opcional)
  rightIconDisable?: boolean; // Desabilitar o ícone da direita (opcional)
  onRightIconClick?: () => void; // Ação para o ícone do lado direito (opcional)
}

export const InfoBox = ({
  iconLeft,
  title,
  text,
  subText,
  iconRight,
  onRightIconClick,
  rightIconDisable,
}: InfoBoxProps) => {
  return (
    <Box sx={styles.infoBox}>
      <Box sx={styles.iconLeft}>{iconLeft}</Box>
      <Box sx={styles.text}>
        <Typography sx={styles.infoTitle}>{title}</Typography>
        <Typography sx={styles.infoText}>{text}</Typography>
        {subText && <Typography sx={styles.infoSubText}>{subText}</Typography>}
      </Box>
      {iconRight && (
        <IconButton
          onClick={onRightIconClick}
          sx={styles.iconRight}
          aria-label="action-icon"
          disabled={rightIconDisable}
        >
          {iconRight}
        </IconButton>
      )}
    </Box>
  );
};

const styles = {
  infoBox: {
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    paddingLeft: '3rem',
  },
  iconLeft: {
    fontSize: '2.4rem',
    color: '#4F4F4F',
  },
  iconRight: {
    fontSize: '2.4rem',
    color: '#4F4F4F',
  },
  infoTitle: {
    color: '#4F4F4F',
    fontSize: '1.2rem',
  },
  infoText: {
    fontSize: '1.4rem',
  },
  infoSubText: {
    color: '#4F4F4F',
    fontSize: '1.2rem',
  },
  text: {
    flexGrow: 1,
  },
};
